/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The station payment types:
 *   * "SMARTPHONE"
 *   * "BANK_CARD"
 *   * "BADGE"
 *   * "LICENSE_PLATE"
 *   * "DKV"
 *   * "ENGIE_CARD"
 *   * "UTA"
 *   * "AS24"
 *   * "AXEGAZ"
 *   * "ROMAC"
 *   * "WEX"
 *   * "OTHER"
 */
export enum PaymentType {
  SMARTPHONE = 'SMARTPHONE',
  BANK_CARD = 'BANK_CARD',
  BADGE = 'BADGE',
  LICENSE_PLATE = 'LICENSE_PLATE',
  DKV = 'DKV',
  ENGIE_CARD = 'ENGIE_CARD',
  UTA = 'UTA',
  AS24 = 'AS24',
  AXEGAZ = 'AXEGAZ',
  ROMAC = 'ROMAC',
  WEX = 'WEX',
  OTHER = 'OTHER'
}
